import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, POST, PUT, GET } from 'helpers/api'
import { regexPhoneNumber, returnSign, formatMoney, formatDate } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [employeeTypes, setEmployeeTypes] = useState([])
	const [productTypes, setProductTypes] = useState([])
	const [permissions, setPermissions] = useState([])

	const [activeTab] = useState(0)
	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/employees',
		response: null
	})

	async function createUpdate(e) {
		e.preventDefault();

		var response;
		let selectedItemCopy = { ...selectedItem }
		selectedItemCopy.permissions = [];

		for (let i = 0; i < permissions.length; i++) {
			for (let j = 0; j < permissions[i]['permissions'].length; j++) {
				if (permissions[i]['permissions'][j]['checked']) {
					selectedItemCopy.permissions.push(permissions[i]['permissions'][j])
				}
			}
		}

		if (selectedItem.id) {
			response = await PUT('/employees', selectedItemCopy, { loader: true })
		} else {
			response = await POST('/employees', selectedItemCopy, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
		}
	}

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/employees"
		var urlParams = ""
		checkFilter()

		// urlParams += returnSign(urlParams) + 'role=ROLE_CASHIER'
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		filterDataCopy.urlParams = urlParams

		// if (`/employees${urlParams}` !== filterUrl)
		// 	setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterData.url, 'response': response.data })
		}

		setFilterData(filterDataCopy)
	}

	function resetFilter() {
		var filterDataCopy = {
			start_date: null,
			end_date: null,
			search: '',
		}
		setFilterData(filterDataCopy)
	}

	function checkFilter() {
		if (
			filterData.start_date === null &&
			filterData.end_date === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function toggleModal(bool = false, item = {}) {
		if (bool) {
			getPermissions(item.login)
			setSelectedItem({ ...item })
		}
		setShowModal(bool)
	}

	function handleInputChange(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[e.target.name] = e.target.value
		if (e.target.name === 'login') selectedItemCopy[e.target.name] = e.target.value.replace(/\s+/g, '').toLowerCase()
		setSelectedItem(selectedItemCopy)
	}

	function selectAll(checked) {
		var permissionsCopy = [...permissions]

		for (let i = 0; i < permissionsCopy[activeTab]['permissions'].length; i++) {
			permissionsCopy[activeTab]['permissions'][i]['checked'] = checked
		}
		permissionsCopy[activeTab]['checked'] = checked

		setPermissions(permissionsCopy)
	}

	function selectOne(checked, index) {
		var permissionsCopy = [...permissions]

		permissionsCopy[activeTab]['permissions'][index]['checked'] = checked

		setPermissions(permissionsCopy)
	}

	function returnStyle(item) {
		var style = {}
		style.width = '90%'
		style.borderBottom = '1px solid #eee'
		if (item.parent_id) {
			style.marginLeft = '20px'
			return style
		}
		if (!item.parent_id) {
			style.fontWeight = '600'
			return style
		}
	}

	async function getEmployeeypes() {
		const response = await GET('/helper/employees-types')
		if (httpOk(response)) setEmployeeTypes(response.data)
	}

	async function getProductTypes() {
		const response = await GET('/helper/products-types')
		if (httpOk(response)) setProductTypes(response.data)
	}

	async function getPermissions(login = 'null') {
		const response = await GET('/helper/permissions', { user_login: login })
		if (httpOk(response)) setPermissions(response.data)
	}

	useEffect(() => {
		getEmployeeypes()
		getProductTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('employees')} [{formatMoney(data?.total)}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '25%' }}>{t('login')}</th>
									<th style={{ 'width': '25%' }}>{t('name')}</th>
									<th style={{ 'width': '10%' }}>{t('phone')}</th>
									<th style={{ 'width': '10%' }}>{t('role')}</th>
									{/* <th style={{ 'width': '20%' }}>{t('type')}</th> */}
									<th style={{ 'width': '20%' }}></th>
									<th style={{ 'width': '10%' }} className="text-nowrap text-center">{t('date')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center" title={item.id}>{item.row_number}</td>
										<td>{item.login}</td>
										<td>{item.name}</td>
										<td>{regexPhoneNumber(item.phone)}</td>
										<td>{item.role_name}</td>
										{/* <td>{item.employee_type_name}</td> */}
										<td>
											{item?.product_types?.map((item2, index2) => (
												<span key={index2}>
													{item2.name}
													{(index2 + 1) !== item?.product_types?.length && ','}
												</span>
											))
											}
										</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered backdrop="static"
				dialogClassName="update-modal-width" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('login')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="login"
								value={selectedItem.login ?? ''} disabled={selectedItem.id}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('password')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="password"
								value={selectedItem.password ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')}</label>
							<input type="number" className="form-control" name="phone"
								value={selectedItem.phone ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						{selectedItem.role !== "ROLE_OWNER" &&
							<div className="form-group">
								<label>{t('employee_types')}</label>
								<Select
									options={employeeTypes}
									value={employeeTypes.find(option => option.id === selectedItem.employee_type_id) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'employee_type_id': option?.id, 'role': option?.role })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}

						{selectedItem.role === "ROLE_WORKSHOP" &&
							<div className="form-group">
								<label>{t('type')}<span className="required-mark">*</span></label>
								<Select
									// isDisabled={selectedItem.id}
									options={productTypes}
									value={selectedItem.product_types}
									onChange={(option) => setSelectedItem({ ...selectedItem, product_types: option })}
									isMulti
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}

						{selectedItem.role === "ROLE_CASHIER" &&
							<div className="d-flex flex-column gap-2 w-100 mt-3">
								{/* <div className="d-flex flex-column" style={{ 'width': '30%' }}>
									{permissions?.map((item, index) => (
										<div key={index} className="cursor"
											style={activeTab === index ? { 'borderBottom': '1px solid #000' } : {}}
											onClick={() => setActiveTab(index)}>
											<span className="link">{item.name}</span>
										</div>
									))}
								</div> */}
								<div className="w-100">
									{permissions.map((item, index) => (
										index === activeTab &&
										<div className="d-flex justify-content-between cursor" key={index}
											onClick={() => selectAll(!item.checked, index)}>
											<h4>{t('all')}</h4>
											<div className="form-check" key={index}>
												<input className="form-check-input" type="checkbox" id="flexCheckChecked"
													checked={item.checked ? true : false}
													onChange={(e) => selectAll(e.target.checked)} />
											</div>
										</div>
									))}

									{permissions[activeTab]?.permissions?.map((item, index) => (
										<div className="d-between bg-hover-grey w-100 cursor" key={index}
											onClick={() => selectOne(!item.checked, index)}>
											<div style={returnStyle(item)}>
												{index + 1}. {item.name_ru}
											</div>
											<div className="form-check" key={index} style={{ 'justifyContent': "flex-end", }}>
												<input className="form-check-input" type="checkbox" id="flexCheckChecked"
													checked={item.checked ? true : false}
													onChange={(e) => {
														e.stopPropagation()
														selectOne(e.target.checked, index)
													}} />
											</div>
										</div>
									))}
								</div>
							</div>
						}

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index
